export const OPTHINES = {
  voteName: '2020project/2020goodperson',
  number: {
    mustRank: true,
  },
  themeColor: {
    activeBgColor: 'rgb(246, 171, 67)',
    inactiveBgColor: '#fff',
  },
  tabs: [
    {
      tabName: '好人评选',
      tabPath: '/20200716RHHR/List',
    },
    {
      tabName: '活动规则',
      tabPath: '/20200716RHHR/Rules',
    },
    {
      tabName: '相关资讯',
      tabPath: '/20200716RHHR/News',
    },
  ],
  mustSearch: false,
};
